import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBoolean = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="Boolean"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M9 10.87 7.566 9.434a.8.8 0 0 0-1.132 1.131l2 2a.8.8 0 0 0 1.132 0l2-2 2-2a.8.8 0 0 0-1.132-1.132z" />
    <path
      fillRule="evenodd"
      d="M9.958 17.75h.084c1.369 0 2.454 0 3.32-.088.888-.09 1.629-.28 2.277-.712a4.8 4.8 0 0 0 1.31-1.311c.434-.648.623-1.39.713-2.277.088-.866.088-1.951.088-3.32v-.084c0-1.369 0-2.454-.088-3.32-.09-.888-.28-1.629-.712-2.277a4.8 4.8 0 0 0-1.311-1.31c-.648-.434-1.39-.623-2.277-.713-.866-.088-1.951-.088-3.32-.088h-.084c-1.369 0-2.454 0-3.32.088-.888.09-1.629.28-2.277.713a4.8 4.8 0 0 0-1.31 1.31c-.434.648-.623 1.39-.713 2.277-.088.866-.088 1.951-.088 3.32v.084c0 1.369 0 2.454.088 3.32.09.888.28 1.629.713 2.277.346.519.791.964 1.31 1.31.648.434 1.39.623 2.277.713.866.088 1.951.088 3.32.088M6.79 16.17c-.77-.079-1.235-.227-1.596-.468a3.3 3.3 0 0 1-.896-.896c-.241-.361-.39-.827-.468-1.596-.08-.781-.08-1.79-.08-3.21s0-2.429.08-3.21c.079-.77.227-1.235.468-1.596a3.3 3.3 0 0 1 .896-.896c.361-.241.827-.39 1.596-.468.781-.08 1.79-.08 3.21-.08s2.429 0 3.21.08c.77.079 1.235.227 1.596.468.355.237.66.542.896.896.241.361.39.827.468 1.596.08.781.08 1.79.08 3.21s0 2.429-.08 3.21c-.079.77-.227 1.235-.468 1.596-.237.355-.541.66-.896.896-.361.241-.827.39-1.596.468-.781.08-1.79.08-3.21.08s-2.429 0-3.21-.08"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBoolean;
